import { render, staticRenderFns } from "./DetailCabang.vue?vue&type=template&id=111ac496&"
import script from "./DetailCabang.vue?vue&type=script&lang=js&"
export * from "./DetailCabang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports